import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    Alert,
    IconButton,
    Box,
    Typography
} from '@mui/material';
import { ApiCall } from '@assets/js/api/commonApi.js';

/**
 * 로그인 모달 컴포넌트
 */
const LoginModal = ({ show, onHide, onLoginSuccess }) => {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    // 입력값 변경 핸들러
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // 입력시 에러 메시지 제거
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    // 유효성 검사
    const validate = () => {
        const newErrors = {};

        if (!formData.username.trim()) {
            newErrors.username = '아이디를 입력해주세요.';
        }

        if (!formData.password.trim()) {
            newErrors.password = '패스워드를 입력해주세요.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // 로그인 처리
    const handleLogin = async (e) => {
        e.preventDefault();

        if (!validate()) { return; }

        setIsLoading(true);

        ApiCall('/login-process', formData).then(async res => {
            if (res && res.success) {
                //로그인 사용자 정보 조회.
                await getUserInfo();
            } else {
                // 로그인 실패
                setErrors({
                    general: res.message || '로그인에 실패했습니다. 아이디와 패스워드를 확인해주세요.'
                });
            }

            setIsLoading(false);
        });
    };

    //사용자 로그인 세션 정보 조회.
    const getUserInfo = async (e) => {
        ApiCall('/auth/userinfo', {}).then(res => {
            if (res && res.success) {
                // 사용자 로그인정보 세션스토리지에 저장
                if (res.data && res.data.data.userInfo) {
                    sessionStorage.setItem('userInfo', JSON.stringify(res.data.data.userInfo));

                    // 성공 콜백 호출
                    onLoginSuccess();
    
                    // 모달 닫기
                    handleClose();
                }else {
                    // 로그인 실패
                    setErrors({
                        general: res.message || '오류가 발생했습니다.'
                    });
                }

            } else {
                // 로그인 실패
                setErrors({
                    general: res.message || '오류가 발생했습니다.'
                });
            }
        });
    }

    // 모달 닫기
    const handleClose = () => {
        setFormData({
            username: '',
            password: ''
        });
        setErrors({});
        onHide();
    };

    // Enter 키 처리
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleLogin(e);
        }
    };

    return (
        <Dialog
            open={show}
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
            disableScrollLock={true}
            disableEnforceFocus={true}
        >
            <DialogTitle>
                로그인
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <i className="bi bi-x-lg"></i>
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <form onSubmit={handleLogin}>
                    {errors.general && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {errors.general}
                        </Alert>
                    )}

                    <TextField
                        fullWidth
                        label="아이디"
                        name="username"
                        type="text"
                        value={formData.username}
                        onChange={handleChange}
                        onKeyPress={handleKeyPress}
                        error={!!errors.username}
                        helperText={errors.username}
                        placeholder="아이디를 입력하세요"
                        disabled={isLoading}
                        required
                        sx={{ mb: 2 }}
                    />

                    <TextField
                        fullWidth
                        label="패스워드"
                        name="password"
                        type="password"
                        value={formData.password}
                        onChange={handleChange}
                        onKeyPress={handleKeyPress}
                        error={!!errors.password}
                        helperText={errors.password}
                        placeholder="패스워드를 입력하세요"
                        disabled={isLoading}
                        required
                        sx={{ mb: 3 }}
                    />

                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={isLoading}
                        sx={{ mb: 2 }}
                    >
                        {isLoading ? '로그인 중...' : '로그인'}
                    </Button>
                </form>

                <Box
                    sx={{
                        mt: 3,
                        pt: 2,
                        borderTop: '1px solid #e0e0e0',
                        textAlign: 'center'
                    }}
                >
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                        <i className="bi bi-info-circle me-2"></i>
                        회원가입은 관리자에게 문의해주세요.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        hatssarjy@gmail.com
                    </Typography>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default LoginModal;
